import MybMigrationDocsUIModel from '../../cms-wrapper/myb-migration-docs';
import asyncActionTypes from '../actions/types.js';

const initialState = {
  loadingMybMigrationDocsCollection: false,
  mybMigrationDocs: [],
  errorMybMigrationDocs: null,
};

const mybMigrationDocs = ( state = initialState, action ) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CMS_MYB_MIGRATION_DOCS.START:
      return {
        ...state,
        loadingMybMigrationDocsCollection: true,
      };
    case asyncActionTypes.RETRIEVE_CMS_MYB_MIGRATION_DOCS.SUCCESS:
      const migrationDocsDescriptions = Object.values(action.payload);
      const migrationDocsDescriptionsByType = [];

      for (let i = 0; i < migrationDocsDescriptions.length; i++) {
        migrationDocsDescriptionsByType.push(new MybMigrationDocsUIModel(migrationDocsDescriptions[i]));
      }

      return {
        ...state,
        loadingMybMigrationDocsCollection: false,
        errorMybMigrationDocs: null,
        mybMigrationDocs: [ ...migrationDocsDescriptionsByType ],
      };
    case asyncActionTypes.RETRIEVE_CMS_MYB_MIGRATION_DOCS.FAIL:
      return {
        ...state,
        loadingMybMigrationDocsCollection: false,
        errorMybMigrationDocs: action.error,
        mybMigrationDocs: [],
      };
    default:
      return state;
  }
};

export default mybMigrationDocs;